export default {
    recipes: [],
    items: [],
}